import { createContext } from "react";
import { FieldState } from "../types";

export type FieldsState = {
  [key: string]: FieldState
}

export const FieldsStateContext = createContext<FieldsState>({});